import type { ReactNode } from 'react';

export interface StepperStep {
  readonly key: string;
  readonly label: string;
}

/**
 * A linear progress indicator for a multi-step flow.
 *
 * `data-status` drives the styling, the same pattern `StatusBadge` uses —
 * a status enum stays a stable CSS selector while the label text carries
 * the translation.
 */
export function Stepper({
  steps,
  activeKey,
}: {
  readonly steps: readonly StepperStep[];
  readonly activeKey: string;
}): ReactNode {
  const activeIndex = steps.findIndex((step) => step.key === activeKey);

  return (
    <ol className="stepper">
      {steps.map((step, index) => (
        <li
          key={step.key}
          className="stepper-item"
          data-status={
            index === activeIndex ? 'current' : index < activeIndex ? 'done' : 'upcoming'
          }
          aria-current={index === activeIndex ? 'step' : undefined}
        >
          {step.label}
        </li>
      ))}
    </ol>
  );
}
